<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <template v-if="hasCreateNew" v-slot:tools>
      <div class="row">
        <div class="col-lg-4 col-sm-6 col-12">
          <el-form :model="toolsForm">
            <el-form-item
              :label="L10n('download-as')"
              prop="invoiceTypeID"
              class="material-style">
              <select-response
                :model.sync="toolsForm.invoiceTypeID"
                :isLoading="dataSourceInvoiceType.loading"
                :data="dataSourceInvoiceType.records"
              ></select-response>
            </el-form-item>
          </el-form>
        </div>
        <div class="d-flex justify-content-center align-items-center col-sm-auto col-12">
          <div v-if="hasDownload">
            <logo-button
              class="btn-mobile-full"
              :get-pdf-content="getPdfContent"
              @click="downloadPDF"
            >
              {{downloadTitle}}
            </logo-button>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center col-sm-auto col-12">
          <logo-button
            class="btn-mobile-full"
            @click="sendEmail"
          >
            {{L10n('send-invoice')}}
          </logo-button>
        </div>
      </div>
    </template>
    <div class="row">
      <div
        class="col-12"
        :class="[`col-xl-${hasCreateNew ? '6' : '12'}`]"
      >
        <form-general-invoice
          ref="Form"
          :data="data"
          :model="formModel"
          :isNew="!hasCreateNew"
          @onChangeRfq="handleChangeRfq"
          @onChangeInvoiceNumber="handlerChangeInvoiceNumber"
          @updateModelItem="handlerUpdateModelItem"
          @change="handleFormData"/>
      </div>
      <div class="col-xl-6 col-12 vb-xl" v-show="hasCreateNew" v-loading="isLoadingSections">
        <editor-rfq
          :mainID="rfqID"
          :sectionID="sections[0].id"
          :hasCreateNew="hasCreateNew"
        ></editor-rfq>
      </div>
      <div class="col-12" v-show="hasCreateNew" v-loading="isLoadingSections">
        <editor-invoice-details
          :mainID="rfqID"
          :sectionID="sections[1].id"
          :invoiceNumber="invoiceNumber"
          :hasCreateNew="hasCreateNew"
        ></editor-invoice-details>
      </div>
    </div>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isSaveEdit="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        @command="setCommand">
        <template v-if="hasCreateNew">
          <div class="control control-send btn-mobile-full mr-sm-2">
            <button
              class="btn btn-size-s btn-mobile-full"
              @click="onUpdateUnitShippedInFollowUp"
            >
              {{L10n('update-unit-shipped-in-follow-up')}}
            </button>
          </div>
          <div class="control control-send btn-mobile-full mr-sm-2">
            <button
              class="btn btn-size-s btn-mobile-full"
              @click="onUpdateStockSale"
            >
              {{L10n('update-stock-sale')}}
            </button>
          </div>
          <div class="control control-send btn-mobile-full mr-sm-2">
            <button
              class="btn btn-size-s btn-mobile-full"
              @click="onUpdateStockExch"
            >
              {{L10n('update-stock-exch')}}
            </button>
          </div>
          <div class="control control-send btn-mobile-full mr-sm-2">
            <button
              class="btn btn-size-s btn-mobile-full"
              @click="onCreatePayment"
            >
              {{L10n('add-to-payment-follow-up')}}
            </button>
          </div>
        </template>
      </form-controls>
    </template>
    <send-email-wrap
      ref="sendEmail"
      :invoiceID="currentID"
      @data-load="isLoading = true"
      @data-loaded="isLoading = false"
    ></send-email-wrap>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { ModelInvoice, ServiceInvoice } from '@/services/Invoice'
import { ServicePayments } from '@/services/Payments'
import { api } from '@/services/api'
import { ServicePdf } from '@/services/pdf-generators'
import { downloadBase64 } from '@/utils/files'

export default {
  name: 'EditorInvoice',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'editor-rfq': () => import(/* webpackChunkName: 'Invoice' */ './EditorRFQSection'),
    'send-email-wrap': () => import(/* webpackChunkName: 'Invoice' */ './SendEmailWrap'),
    'editor-invoice-details': () => import(/* webpackChunkName: 'Invoice' */ './EditorInvoiceDetailsSection'),
    'form-general-invoice': () => import(/* webpackChunkName: 'Invoice' */ './FormGeneralInvoice')
  },
  data () {
    return {
      rfqID: null,
      invoiceNumber: null,
      isLoadingSections: false,
      sections: [
        {
          id: 'section-rfq'
        },
        {
          id: 'section-invoice-details'
        }
      ],
      // eslint-disable-next-line
      apiPatch: 'Invoices/Patch/${data.id}',
      toolsForm: {
        invoiceTypeID: null
      }
    }
  },
  watch: {
    formData (value) {
      this.toolsForm = { invoiceTypeID: (value && value.invoiceTypeID) || null }
    }
  },
  computed: {
    formTitle () {
      return this.formData.invoiceNumber
    },
    dataSourceInvoiceType () {
      return this.API('InvoiceTypes/GetAllDynamic?Select=id,title,emailContent&OrderBy=title')
    },
    invoiceType () {
      return this.dataSourceInvoiceType.map[this.toolsForm.invoiceTypeID]
    },
    hasDownload () {
      return this.hasCreateNew && this.invoiceType && this.formData.invoiceNumber
    },
    downloadTitle () {
      let title = this.invoiceType && this.invoiceType.title
      return [this.L10n('download'), title].filter(Boolean).join(' ')
    },
    currentUser () {
      return this.$store.getters.get('currentUser')
    }
  },
  methods: {
    async onUpdateUnitShippedInFollowUp () {
      this.isLoading = true
      try {
        await ServiceInvoice
          .updateUnitShippedInFollowUp({ invoiceNumber: this.invoiceNumber, rfqid: this.data.rfqid })
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e, e.message)
      } finally {
        this.isLoading = false
      }
    },
    async onUpdateStockSale () {
      this.isLoading = true
      try {
        await ServiceInvoice
          .updateStockSales({ invoiceNumber: this.invoiceNumber, rfqid: this.data.rfqid })
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e, e.message)
      } finally {
        this.isLoading = false
      }
    },
    async onUpdateStockExch () {
      this.isLoading = true
      try {
        await ServiceInvoice
          .updateStockExch({ invoiceNumber: this.invoiceNumber, rfqid: this.data.rfqid })
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e, e.message)
      } finally {
        this.isLoading = false
      }
    },
    sendEmail (logoType) {
      this.$refs.sendEmail.show({ logoType })
    },
    async onCreatePayment () {
      this.isLoading = true
      try {
        const { data: dataPayment } = await ServicePayments.getPaymentDataByInvoice({ invoiceID: this.currentID })
        await ServicePayments.post(dataPayment)
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async downloadPDF (logoKey) {
      this.isLoading = true
      const { invoiceNumber } = this.formData
      const { invoiceTypeID } = this.toolsForm
      const id = this.currentID
      try {
        const { data: pdfBase64 } = await ServicePdf.generateInvoice({ id, invoiceTypeID, translate: this.L10n, logoKey })
        await downloadBase64(pdfBase64, `${invoiceNumber}.pdf`)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async getPdfContent () {
      const { invoiceTypeID } = this.toolsForm
      const id = this.currentID
      return ServicePdf.generateInvoiceContent({ id, invoiceTypeID, translate: this.L10n })
    },
    formModel () {
      return ModelInvoice()
    },
    handleChangeRfq (rfqid) {
      if (!this.hasCreateNew && rfqid) {
        // Create and continue
        this.setCommand('save_edit')
      } else {
        this.updateSections('rfqID', rfqid)
      }
    },
    handlerChangeInvoiceNumber (invoiceNumber) {
      this.updateSections('InvoiceNumber', invoiceNumber)
    },
    updateSections (field, value) {
      if (!this.hasCreateNew || !value) return
      this[field] = value
      this.createInvoiceDetails()
        .then(() => {
          this.$bus.$emit('Call-Update-Section')
        })
    },
    createInvoiceDetails () {
      this.isLoadingSections = true
      const rfqid = encodeURIComponent(this.rfqID)
      return api
        .post(`InvoiceDetails/CreateDynamic/${this.currentID}/${rfqid}`)
        .then(() => {
          this.isLoadingSections = false
        })
        .catch(error => {
          this.isLoadingSections = false
          this.requestErrorHandler(error)
        })
    },
    // From mixin
    handleChangeData () {
      if (this.data.rfqid && this.data.invoiceNumber) {
        this.rfqID = this.data.rfqid
        this.invoiceNumber = this.data.invoiceNumber
        setTimeout(() => {
          this.$nextTick(() => {
            this.$bus.$emit('Call-Update-Section')
          })
        }, 1000)
      }
    },
    save (isEditAfter = false) {
      if (!this.$refs.Form) {
        // eslint-disable-next-line
        return console.error('not found form')
      }
      // validate
      this.$refs.Form.validate()
        .then(() => {
          return this.validateSections()
        })
        .then(() => {
          return this.saveSections()
        })
        .then(() => {
          this.isLoading = true
          // check to save execute components
          this.checkExecuteFirst().then(_ => {
            // save/create main object
            if (this.currentID) {
              // update
              this.$bus.$emit(`Call-Grid-Patch-${this.config.id}`,
                this.handlePrepareData(this.$refs.Form.getData(), 'update'),
                this.gridPatchHandler
              )
            } else {
              // create
              this.$bus.$emit(`Call-Grid-Create-${this.config.id}`,
                this.handlePrepareData(this.$refs.Form.getData(), 'create'),
                response => this.gridCreateHandler(response, isEditAfter)
              )
            }
          })
        })
        .catch(() => this.setQuery('edit'))
    },
    createPromiseRequest (eventPrefix) {
      if (!this.hasCreateNew) return
      return Promise.all(this.sections.map((section) => {
        return new Promise((resolve, reject) => {
          const callback = function (result) {
            if (result instanceof Error) {
              reject(result)
            } else {
              resolve()
            }
          }
          this.$bus.$emit(`${eventPrefix}-${section.id}`, callback)
        })
      }))
    },
    validateSections () {
      return this.createPromiseRequest('Call-Validate-Section')
    },
    saveSections () {
      return this.createPromiseRequest('Call-Save-Section')
    }
  }
}
</script>

<style lang="stylus">
  .control-send{
    order 4
  }
  .control-download{
    order 5
  }
</style>
